import { render, staticRenderFns } from "./ConfirmRemoveBillingAddress.vue?vue&type=template&id=dee5026a"
import script from "./ConfirmRemoveBillingAddress.vue?vue&type=script&lang=js"
export * from "./ConfirmRemoveBillingAddress.vue?vue&type=script&lang=js"
import style0 from "./ConfirmRemoveBillingAddress.vue?vue&type=style&index=0&id=dee5026a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports